package com.taocent.simple.compose.component.blockrichtext.internal.block.renderer

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.taocent.simple.compose.component.blockrichtext.BlockState
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import com.taocent.simple.compose.component.blockrichtext.TableBlock
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockKind
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockRenderer
import kotlin.reflect.KClass

@OptIn(ExperimentalBlockRichTextApi::class)
class TableBlockRenderer : BlockRenderer<TableBlock> {

    override val kind: BlockKind get() = BlockKind.TABLE

    override val blockClass: KClass<TableBlock>
        get() = TableBlock::class

    @Composable
    override fun Render(
        block: TableBlock,
        blockState: BlockState,
        modifier: Modifier
    ) {
        TableRenderer(
            block = block,
            blockState = blockState,
            modifier = modifier.fillMaxWidth(),
        )
    }
}
